import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import { swiperControlsConfig } from '../../../../../../src/js/utils/swiper-controls'

function initOfferingsSliders() {
    const sliders = document.querySelectorAll('.offerings-swiper')
    if (!sliders.length) return

    sliders.forEach((el) => {
        if (el.swiper) return

        const root = el.closest('.offerings-slider')

        new Swiper(el, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            loop: false,
            speed: 600,
            grabCursor: true,
            watchOverflow: true,
            ...swiperControlsConfig(root),
            breakpoints: {
                768: {
                    spaceBetween: 24,
                    slidesOffsetBefore: 24,
                    slidesOffsetAfter: 24,
                },
                1024: {
                    spaceBetween: 28,
                    slidesOffsetBefore: 28,
                    slidesOffsetAfter: 28,
                },
            },
        })
    })
}

document.addEventListener('DOMContentLoaded', initOfferingsSliders)
